<template>
    <div>
        <div class="title-box">
            <div class="title-box-wrapper">
                <span class="title">{{ t('All products from monitored categories') }} <span v-if="!own">({{ t('including competing producers') }})</span></span>
            </div>
        </div>

        <div class="wrapper">

            <div class="bg">
                <div class="inner">
                    <div class="row">
                        <div class="col-lg-12">

                            <div class="control-group">
                                <div class="controls form-inline">
                                    <div id="datatable-search-box" class="pull-left"></div>
                                    <div id="datatable-length-box" class="pull-left"></div>

                                    <div class="pull-left">
                                        <label>
                                            <select v-model="category" @change="changeCategory(category)" name="category" class="form-control">
                                                <option v-for="category in categories" v-bind:value="category.id">
                                                    {{category.name}}
                                                </option>
                                            </select>
                                        </label>
                                        <label v-for="attribute in attributes">
                                            <select v-bind:name="attribute.id" v-model="filter[attribute.id]" class="form-control">
                                                <option value="0">{{attribute.name}}</option>
                                                <option v-for="value in attribute.values" v-bind:value="value.id">
                                                    {{ value.name }}
                                                </option>
                                            </select>
                                        </label>
                                        <label>
                                            <price-range v-model="priceRange" @update="updatePriceRange" :interval="2000"></price-range>
                                        </label>
                                        <button @click="showFilters = false; initDT();" class="btn btn-confirm">{{ t('Filter') }}</button>

                                        <!--<select v-model="report" @change="changeReport(report);" name="reports" class="form-control">-->
                                            <!--<option v-for="report in reports" v-bind:value="report.id">{{report.name}}</option>-->
                                        <!--</select>-->

                                        <!--<button @click="toggleFilter()" class="btn btn-confirm" v-show="!showFilters">{{ t('Show filters') }}</button>-->
                                        <!--<button @click="toggleFilter()" class="btn btn-confirm" v-show="showFilters">{{ t('Hide filters') }}</button>-->
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <br />

            <div id="table-wrapper"></div>

            <div class="row">
                <div class="col-lg-12">
                    <form :action="$http.options.root + '/reports/dump/' + category" method="get" target="_blank" class="form-inline">
                        <input type="hidden" name="own" v-bind:value="own" />
                        <input type="hidden" name="category" v-bind:value="category" />
                        <input type="hidden" name="search" v-bind:value="searchValue" />
                        <input type="hidden" name="report" v-bind:value="report" />

                        <select v-for="attribute in attributes" v-bind:name="'filter['+attribute.id+']'" v-model="filter[attribute.id]" class="form-control hide">
                            <option value="0">-</option>
                            <option v-for="value in attribute.values" v-bind:value="value.id">
                                {{ value.name }}
                            </option>
                        </select>

                        <div v-for="(condition_item, index) in rule.conditions">
                            <input type="hidden" v-bind:name="'conditions['+index+']['+key+']'" v-bind:value="cond" v-for="(cond,key) in condition_item" />
                        </div>

                        <button type="submit" class="btn btn-confirm btn-sm">{{ t('Export') }}</button>
                        <!--<button @click="showExportCols=!showExportCols" v-show="!showExportCols" type="button" class="btn btn-confirm btn-sm">-->
                            <!--&raquo;&raquo;-->
                        <!--</button>-->

                        <!--<select v-show="showExportCols" multiple name="col[]" v-model="selectedCols" class="form-control">-->
                            <!--<option v-if="column.data !== 'toggle'" v-for="column  in columns" :value="column.data">{{ column.name }}</option>-->
                        <!--</select>-->
                    </form>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    window.jQuery = $;
    require('datatables.net-bs');
    require('datatables.net-fixedcolumns');
    require('bootstrap');
    require('bootstrap-multiselect/dist/js/bootstrap-multiselect');

    import Vue from 'vue';
    import ProductDetails from './ProductDetails.vue';
    import {product, shops} from '../services';
    import router from '../router';
    import PriceRange from './PriceRange';

    let ProductDetailsLoader = Vue.extend(ProductDetails);

    export default {
        name: 'DataGrid',
        props: ['own'],
        components: {PriceRange},
        data() {
            return {
                condition: {},
                showExportCols: false,
                selectedCols: [],
                showFilters: false,
                categories: [],
                category: 1,
                categorySelected:1,
                reports: [],
                report: 0,
                reportSelected: 0,
                columns: [],
                attributes: [],
                dtLength: null,
                filter: {},
                dt: {
                    forceID: null,
                    instance: null,
                    options: {
                        language: {
                            "processing": this.$translate.text("Processing")+'...',
                            "search": this.$translate.text("Search")+':',
                            "lengthMenu": this.$translate.text("Show _MENU_ position"),
                            "info": this.$translate.text("Position _START_ - _END_ of _MAX_"),
                            "infoEmpty": this.$translate.text("Position 0 of 0 available"),
                            "infoFiltered": "",
                            "infoPostFix": "",
                            "loadingRecords": this.$translate.text("Loading")+'...',
                            "zeroRecords": this.$translate.text("Records not found"),
                            "emptyTable": this.$translate.text('Not found'),
                            "paginate": {
                                "first": this.$translate.text("First"),
                                "previous": this.$translate.text("Previous"),
                                "next": this.$translate.text("Next"),
                                "last": this.$translate.text("Last")
                            },
                            "aria": {
                                "sortAscending": ': ' + this.$translate.text("active to asc sort column"),
                                "sortDescending": ': '+ this.$translate.text("active to desc sort column")
                            }
                        },
                        scrollX: true,
//                        scrollCollapse: true,
//                        fixedColumns: {
//                            leftColumns: 1
//                        },
                        autoWidth: true,
                        sort: true,
                        searching: true,
                        paging: true,
                        lengthMenu: [[10, 50, 100, 250, 500], [10, 50, 100, 250, 500]],
                        iDisplayLength: 50,
                        processing: true,
                        serverSide: true,
                        columnDefs: [
                            { "orderable": false, "targets": 'no-sort' }
                        ],
                    }
                },
                rule: this.getDefaultRules(),
                ruleCleaned: true,
                shops: [],
                searchValue: null,
                importDate: null,
                priceRange: {
                    startPrice: null,
                    endPrice: null,
                }
            }
        },
        mounted() {
            const v = this;

            shops.getShops(this, (response) => {
                this.shops = response.body;

                setTimeout(function () {
                    if (v.$route.params.id) {
                        repricing.getOne(v, v.$route.params.id, (response) => {
                            v.rule = response.body.rule;
                            v.attributes = response.body.inputAttributes;

                            v.doMultiSelectTimeout(10);
                        })
                    }
                    else {
                        v.doMultiSelect()
                    }
                }, 10)
            })
            this.initPage();
        },
        methods:
        {
            updatePriceRange()
            {
                this.initDT();
            },
            getDefaultRules(){
                return {
                    name: '',
                    description: '',
                    conditions: [
                        {
                            enabled: false,
                            type: 4,
                            priceCondition: 1,
                            method: 1,
                            competitors: [],
                            amount: 0,
                            amountType: 1
                        },
                    ],
                    guard: {
                        pricePercent: 0,
                        type: 1,
                        profitMargin: 0,
                        profitMarginType: 1
                    }
                };
            },
            changeReport(report){
                if(report == this.reportSelected){
                    return;
                }
                this.reportSelected = report;
                this.initDT();
            },
            submit() {
                this.initDT();
                this.ruleCleaned = false;
            },
            clearFilters(){
                this.rule = this.getDefaultRules();
                $('#shops-select').multiselect("clearSelection");
                if(this.ruleCleaned){
                    return;
                }
                this.ruleCleaned = true;
                this.initDT();
            },
            doMultiSelect() {
                const v = this
                $('#shops-select').multiselect({
                    onChange: function () {
                        for (const i in v.rule.conditions) {
                            if (typeof v.rule.conditions[i].competitors != 'undefined') {
                                v.rule.conditions[i].competitors = $('#shops-select').val();
                            }
                        }
                    },
                    nonSelectedText: this.$translate.text('Select competitors'),
                    nSelectedText: ' '+this.$translate.text('selected'),
                    buttonWidth: '170px',
                    numberDisplayed: 1
                });
            },
            doMultiSelectTimeout(timeout) {
                const v = this
                setTimeout(() => {
                    v.doMultiSelect()
                }, timeout)
            },
            changeCategory(id)
            {
                this.$http.get('reports/init', {params: {category: this.category, brands: 1}}).then(response => {
                    this.attributes = this.attributes.map(row => {
                        if (row.id == response.body.id) {
                            return response.body;
                        }

                        return row;
                    });
                    this.category = id;
                });

            },
            toggleFilter() {
                this.showFilters = !this.showFilters
            },
            initPage(params)
            {
                params = params || {};

                params.own = this.own;
                params.category = this.category;

                this.$http.get('reports/init', {params: params || {}}).then((response) =>
                {
                    this.importDate = response.body.import_date;
                    this.categories = response.body.categories
                    if (response.body.category) {
                        this.category = response.body.category
                    }
                    else if (response.body.categories[0]) {
                        this.category = response.body.categories[0].id
                    }

                    this.reports = response.body.reports
                    if (response.body.report) {
                        this.report = response.body.report
                    }
                    else if (response.body.reports[0]) {
                        this.report = response.body.reports[0].id
                    }

                    if (response.body.filter) {
                        this.filter = response.body.filter;
                    }

                    this.attributes = response.body.attributes
                    this.columns = response.body.columns
                    this.initDT();
                })
            },
            initDT() {
//                console.trace();
                const v = this
                let tableHeaders = ''

                for (let i in this.columns) {
                    if (this.columns.hasOwnProperty(i)) {
                        tableHeaders += '<th>' + this.columns[i].name + '</th>';
                    }
                }

                this.dt.options.columns = this.columns
                this.dt.options.ajax = function (data, callback) {
                    // some issue with 'length' prop
                    data.page_length = data.length
                    delete data.length

                    delete data.columns

                    data.category = v.category
                    data.report = v.report
                    data.conditions = v.rule.conditions;
                    data.filter = {};

                    for (let key in v.filter) {
                        if (typeof v.filter[key] !== undefined) {
                            data.filter[key] = v.filter[key];
                        }
                    }

                    if (v.dt.forceID) {
                        data.forceID = v.dt.forceID;
                    }
                    if (v.own) {
                        data.own = true;
                    }

                    data.start_price = v.priceRange.startPrice;
                    data.end_price = v.priceRange.endPrice;

                    v.$http.get('reports/dt', {params: data}).then((response) => {
                        callback(response.body)
                        v.searchValue = response.body.searchValue;
                        v.category = response.body.category;
                    })
                }

                if (this.dt.instance !== null) {
                    this.dt.instance.destroy();
                }

                $('#table-wrapper')
                    .empty()
                    .append('<table id="datagrid" class="table" cellspacing="0" style="width:100%;">' +
                        '<thead><tr>' + tableHeaders + '</tr></thead></table>');

                let datagrid = $('#datagrid');

                this.dt.instance = datagrid.DataTable(this.dt.options);

                this.$store.dispatch('setDT', this.dt)

                // open product (row) details
                datagrid.find('tbody').on('click', 'tr td .row-details', (e) => {
                    e.preventDefault();

                    let a = $(e.target);
                    let ag = $(a).find('.glyphicon');

                    let tr = a.closest('tr');
                    let id = $(tr).attr('id');

                    let row = v.dt.instance.row(tr);

                    if (row.child.isShown()) 
                    {
                        row.child.hide();
                        
                        $(ag).removeClass('glyphicon-chevron-up');
                        $(ag).addClass('glyphicon-chevron-down');
                    }
                    else 
                    {
                        $(ag).removeClass('glyphicon-chevron-down');
                        $(ag).addClass('glyphicon-chevron-up');

                        let container=row.child(() => {
                            return '<div class="loading-fragment"><div class="dataTables_processing panel panel-default">'+this.$translate.text('Processing')+'...</div></div>';
                        });
                        container.show();
                        v.$http.get('reports/details', {params: {id: id}}).then((response) =>
                        {
                            let data = {
                                data: Object.assign({importDate: this.importDate}, response.body)
                            };

                            new ProductDetailsLoader(data).$mount($(row.child()[0]).find('div')[0])
                        })
                    }
                });

                let dtSearch = $('#datagrid_filter'), newDtSearch = $('#datatable-search-box');
                let dtSearchInput = dtSearch.find('input[type="search"]');

                newDtSearch.empty();

                if (!newDtSearch.has('input').length)
                {
                    dtSearchInput.addClass('form-control');
                    dtSearchInput.removeClass('input-sm');

                    dtSearchInput.attr('placeholder', this.$translate.text('Search name / Index / Ean'));

                    newDtSearch.append(dtSearchInput);
                }

                dtSearch.remove();

                let dtLength = $('#datagrid_length'), dtBox = $('#datatable-length-box');
                let dtLengthInput = dtLength.find('select');

                if (v.dtLength !== null) {
                    dtLengthInput.val(v.dtLength);
                    dtLengthInput.trigger('change');
                }

                dtBox.html( dtLengthInput.removeClass('input-sm') );
                dtLength.remove();

                $('select[name="datagrid_length"]').change(function(){
                    v.dtLength = $(this).val();
                });

                // change repricing rule for product
                datagrid.find('tbody').on('click', 'tr td .rule-change', (e) => {
                    e.preventDefault()

                    let a = $(e.target)
                    let select = a.parent().find('.rule-select')

                    a.hide();
                    select.show().focus();

                    select.off('change').on('change', () => {
                        product.changeRule(v, {repricing_rule_id: select.val()}, select.data('id'), response => {
                            a.html(select.find('option:type').text()).show()
                            select.hide();
                            if (response.body) {
                                $('#proposed-price-' + response.body.product_id).html(response.body.proposed_price)
                            }
                        })
                    })
                    select.off('blur').on('blur', () => {
                        a.show()
                        select.hide()
                    })
                });

                // close product from notifications
                datagrid.find('tbody').on('click', 'tr td .close-preview', (e) => {
                    this.$store.dispatch('closeProductFromNotification')
                });
            }
        }
    }
</script>

<style lang="sass">
    @import "./../../node_modules/datatables.net-bs/css/dataTables.bootstrap.css";
    @import "./../../node_modules/bootstrap-multiselect/dist/css/bootstrap-multiselect.css";

    /*table {
        background: #fff;
    }
    table.dataTable {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }
    .DTFC_LeftBodyLiner {
        top: -2px !important;
    }*/
    /*.dataTable tbody tr {
        height: 35px; !* or whatever height you need to make them all consistent *!
    }
    .dataTable th {
        background: #fff;
    }*/

    .status {
        &.inactive {
            color: red;
        }

        &.active {
            color: green;
        }
    }

    .amount {
        width: 100px;
        display: inline-block;
    }

    .w100 {
        width: 280px;
    }

    .w75 {
        width: 205px;
    }

    .w50 {
        width: 130px;
    }

    input[type="number"], input[type="amount"] {
        width: 70px;
    }

    .input-block {
        display: inline-block;
    }

    .col-fixed, .price-rules {
        min-width: 720px;
    }

    .arrows {
        line-height: 10px;
    }

    .arrow {
        display: inline-block !important;
        width: 9px;
        height: 6px;
    }

    .arrow-up {
        background: url('../assets/img/up.png') no-repeat 0 0;
    }

    .arrow-up:hover {
        background-position: -9px;
    }

    .arrow-down {
        background: url('../assets/img/down.png') no-repeat 0 0;
    }

    .arrow-down:hover {
        background-position: -9px;
    }

    .price-rules .text {
        line-height: 20px;
    }

    .loading-fragment{
        position: relative;
        height:100px;
    }

    table.dataTable .ph{
        float:right;
    }

    .dataTables_wrapper .glyphicon {
        padding-left: 5px;
    }
    select{
    max-width: 200px;
    }
</style>



// WEBPACK FOOTER //
// DataGrid.vue?893f35c6